import {
  NavigationWithUserContext,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { CancelPortoutPage } from "@nju/feature-portal-msisdn";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../components/ClientSideRenderer";

export default function CancelPortout() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <ClientSideOnly>
          <RequiredDashboardData extendedMode="mobile">
            <NavigationWithUserContext />
            <CancelPortoutPage />
          </RequiredDashboardData>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
